import React from 'react';
import PropTypes from 'prop-types';
import Song from '../Song';
import { Button, Icon, Popup } from 'semantic-ui-react';
import styles from '../Playlist.scss';
import Summary from '../Summary';
import { RootConsumer } from '../../RootComponent';
import { MobileModal } from '../../Modules';

const PlaylistRecommendation = ({
  addToPlaylist,
  onClose,
  node,
  parent
}) => {
  const addedLabel = (
    <Button
      className={styles.noBoxShadow}
      circular
      basic
      size='small'
      icon='check'
      disabled
    />
  );

  const addButton = (
    <Popup
      content='Add to Playlist'
      inverted
      position='top center'
      trigger={
        <Button
          className={styles.noBoxShadow}
          circular
          basic
          type='button'
          size='small'
          icon='add'
        />
      }
    />
  );

  const playlistContainsSong = (song) => {
    for (const playlistSong of parent.playlist_songs.edges) {
      if (playlistSong.node.song.isrc === song.isrc) return true;
    }
    return false;
  };

  return (
    <RootConsumer>
      {({ isMobile }) => (
        <div>
          <Summary playlist={node} />
          {isMobile &&
            <MobileModal.Header>
              <div className='menu'>
                <a className='item' onClick={onClose}>
                  <Icon
                    name='chevron left'
                  />
                </a>
              </div>
            </MobileModal.Header>}
          <p className={styles.playlistLabel} style={{ marginTop: '2em' }}>
            Playlist
          </p>
          {node.playlist_songs.edges.map(({ node: { song } }) =>
            <Song
              key={song.id}
              song={song}
              actionCallback={
                playlistContainsSong(song) ? () => {} : addToPlaylist
              }
              actionTrigger={
                playlistContainsSong(song) ? addedLabel : addButton
              }
            />
          )}
        </div>
      )}
    </RootConsumer>
  );
};

PlaylistRecommendation.propTypes = {
  addToPlaylist: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  node: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired
};

export default PlaylistRecommendation;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/index.js